module.exports = __webpack_public_path__ + "static/media/office6.65b5bfff.jpg";